import axios from 'axios';

// https://app.labs.ai/managedbots/party/12345?language=en&returnDetailed=false&returnCurrentStepOnly=true&returningFields=conversationOutputs

export const instance = axios.create({
  baseURL: 'http://localhost:7070/managedbots/',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json'
  }
});
instance.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return Promise.reject(error);
});
instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  console.log('error: ', error);
  console.log(`Error: ${JSON.stringify(error)}`);
  return Promise.reject(error);
});
//# sourceMappingURL=instance.js.map